<template>
  <div style="border: 0px solid orange;">

    <!-- SINGLE KEY -->

    <v-row v-if="Object.keys(item1 || {}).length === 1">
      {{ Array.isArray(item1) ? '[' : '{' }}
      <template v-for="(v, k) in item1">
        <kv-row :k="k" :item1="v" :item2="(item2 || {})[k]" :key="k" class="ml-1" style="flex-grow: 0;" :settings="settings"></kv-row>
      </template>
      {{ Array.isArray(item1) ? ']' : '}' }}
    </v-row>
    <!-- SINGLE KEY -->

    <!-- MUTLIPLE KEYS -->
    <template v-else>
      <v-row 
      @click="expand = !expand" 
      :class="[['expandable-header align-center'], {'red--text': !isEqual}]">
        <v-icon :class="{'rotate-90': expand}" small>
          mdi-menu-right
        </v-icon>
        <template>
          {{ Array.isArray(item1) ? '[' : '{' }}
          <span class="grey--text">
            ...{{ Object.keys(item1 || {}).length }}
          </span>
        </template>
        <template v-if="!expand">
          {{ Array.isArray(item1) ? ']' : '}' }}
        </template>
        &nbsp;
        <span v-if="settings.showTypes" class="grey--text caption font-weight-regular">
          {{ Array.isArray(item1) ? 'array' : typeof item1 }}
        </span>
      </v-row>
      <!-- OBJECT -->
      <v-expand-transition>
        <v-sheet v-show="expand">
          <template v-for="k in Object.keys(item1).sort()">
            <kv-row :k="k" :item1="item1[k]" :item2="(item2 || {})[k]" :key="k" class="ml-4" :settings="settings"></kv-row>
          </template>
          <div style="margin-left: 14px;" :class="{'red--text': !isEqual}">
            {{ Array.isArray(item1) ? ']' : '}' }}
          </div>
        </v-sheet>
      </v-expand-transition>
    </template>
  </div>
</template>

<script>
import KvRow from './kv-row'

export default {
  props: ['item1', 'item2', 'settings'],
  name: 'object-row',
  components: {
    'kv-row': KvRow
  },
  data () {
    return {
      expand: false
    }
  },
  computed: {
    isEqual () {
      return _.isEqual(this.item1, this.item2)
    }
  }
}
</script>

<style scoped lang="scss">
.expandable-header {
  cursor: pointer;
}
</style>
